export default __webpack_public_path__ + "static/media/ReduxSaga.7a3e8442.png";